export default __webpack_public_path__ + "static/review_stars-0bacdc6673b779e2c5412d7aebab6e54.svg";